jQuery(document).ready(function ($) {
//   $(".top-header-person .ico_user").on("click", function(e) {
//     e.stopPropagation();
//     $(".hl-right-top .caart-header.custom").slideToggle("fast");
//   });
  
  $(".account-top-header").on("click", function(e) {
    e.stopPropagation();
    $(".hl-right-top .caart-header.custom").slideToggle("fast");
    $(this).toggleClass('open');
  });

  $("#bck-top").click(function () {
    $("body, html").animate({
      scrollTop: 0
    }, 400);
    return false;
  });

  $(window).scroll(function () {
    if ($(this).scrollTop() > 150) {
      $(".footer_collection_fixed").addClass("on");
    } else {
      $(".footer_collection_fixed").removeClass("on");
    }
  });

  function Utils() {
  }

  Utils.prototype = {
    constructor: Utils,
    isElementInView: function (element, fullyInView) {
      try {
        var pageTop = $(window).scrollTop();
        var pageBottom = pageTop + $(window).height();
        var elementTop = $(element).offset().top;
        var elementBottom = elementTop + $(element).height();
        if (fullyInView === true) {
          return ((pageTop < elementTop) && (pageBottom > elementBottom));
        } else {
          return ((elementTop <= pageBottom) && (elementBottom >= pageTop));
        }
      } catch (e) {
      }
    }
  };

  var Utils = new Utils();
  var lastScrollTop = 0;
  $(window).scroll(function () {
    try {
      var st = $(this).scrollTop();
      var scrollTop = $(window).scrollTop(),
          elementOffset = $('.product-qty-cart .qty-bag').offset().top,
          distance = (elementOffset - scrollTop);
    } catch (e) {
    }
    
    if (st > lastScrollTop) {
      var isElementInView = Utils.isElementInView($('.product-qty-cart .qty-bag'), false);
      if (isElementInView) {
        $('.product-qty-cart .mob-cart').removeClass("on");
      } else {
        if (distance < 0) {
          $('.product-qty-cart .mob-cart').addClass("on");
        }
      }
    } else {
      var isElementInView = Utils.isElementInView($('.product-qty-cart .qty-bag'), false);
      if (isElementInView) {
        // console.log('in view');
        $('.product-qty-cart .mob-cart').removeClass("on");
      } else {
        //  console.log('out of view');
        if (distance < 0) {
          $('.product-qty-cart .mob-cart').addClass("on");
        }
      }
    }
    lastScrollTop = st;
  });


  $(window).on('load', function () {
    $('.nonFeaturedBrands > li').each(function () {
      $(this).attr('id', $(this).children('h3').text());
    });
    
    $('.brand-tabs-alphabet > li').each(function () {
      if($('#'+$(this).children('a').text()).length==0){
         $(this).attr('class', $(this).attr('class')+' hidden');
      }
    });
    $('.brand-tabs-alphabet').show();
  });

  jQuery('.brand-tabs-alphabet-item a[href*=\\#]:not([href=\\#])').click(function (event) {
    var dis_top = $($.attr(this, 'href')).offset().top;
    if($('body').hasClass("have-fixed")){
      jQuery('html,body').animate({
        scrollTop: dis_top - 50
      }, 1000);
    }else{
      jQuery('html,body').animate({
        scrollTop: dis_top - 120
      }, 1000);
    }
    return false;
    event.preventDefault();
  });
  
//   $('#PopupSignupForm_0').click(function(){
//    $('.mc-banner').parent().hide();
//     $.cookie('MCPopupClosed', 'yes');
//   });
});